import { eventbus } from '../../../../../shared/services/event-bus/event-bus.service';

type IImageCropperChannelProps = {
  onImageCropped: (payload: { image: File }) => void;
};

export const imageCroppedChannel = eventbus<IImageCropperChannelProps>();
